import { Badge } from '@ixigo/iui/badge';
import { cn } from '@ixigo/iui/variantStyle';
import { IXIGO_LOGO } from './brand';

/** The ixigo logo + a tilted lime "Creators" stamp (nav and footer). */
export function CreatorsWordmark({ className }: { className?: string }) {
	return (
		<span className={cn('flex items-center gap-2', className)}>
			<img
				src={IXIGO_LOGO.src}
				alt={IXIGO_LOGO.alt}
				width={IXIGO_LOGO.width}
				height={IXIGO_LOGO.height}
				className="h-8 w-auto"
			/>
			<Badge
				type="tag"
				className="-rotate-3 rounded-full !bg-creators-lime px-2.5 py-1 text-[11px] font-bold uppercase leading-none tracking-[0.12em] !text-black [&>span]:py-0"
			>
				Creators
			</Badge>
		</span>
	);
}
